import { render, staticRenderFns } from "./NestedRouteComponent.vue?vue&type=template&id=e1b3606c"
import script from "./NestedRouteComponent.vue?vue&type=script&lang=js"
export * from "./NestedRouteComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports